var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V31.9957H0V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17890_38628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0078125H32V32.0036H0V0.0078125Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17890_38628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.0133V28.0062H28V16.0078",
    stroke: "#373737",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10.0078L16 4.00781L10 10.0078",
    stroke: "#373737",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3388V4.00781",
    stroke: "#373737",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UploadFile.f05e40da.svg";
export { ForwardRef as ReactComponent };